module.exports = __webpack_public_path__ + "f9fcb965c222db587018cac53c8e5379.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-22.png
// module id = 1534
// module chunks = 0